import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  pageRoot: {
    backgroundColor: "#F5F7FA",
    padding: theme.spacing(2.5),
    minHeight: "100%",
  },

  dialogPaper: {
    borderRadius: 16,
    overflow: "hidden",
  },
  dialogHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1.5),
    padding: theme.spacing(2, 2.5),
    backgroundColor: "#f8fafc",
    borderBottom: "1px solid #eef0f3",
  },
  dialogHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
  dialogHeaderIcon: {
    width: 44,
    height: 44,
    borderRadius: 12,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(17, 98, 254, 0.1)",
    color: theme.palette.primary.dark,
  },
  dialogTitleText: {
    fontSize: "1.1rem",
    fontWeight: 700,
    color: "#1f2937",
    lineHeight: 1.2,
  },
  dialogSubtitle: {
    fontSize: "0.85rem",
    color: theme.palette.text.secondary,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  dialogTypeChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 5,
    flexShrink: 0,
    fontSize: "0.78rem",
    fontWeight: 600,
    padding: "5px 12px",
    borderRadius: 999,
  },
  dialogBody: {
    padding: theme.spacing(2.5),
  },
  detailRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    "&:last-child": { marginBottom: 0 },
  },
  detailIcon: {
    width: 36,
    height: 36,
    borderRadius: 10,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f1f5f9",
    color: "#64748b",
  },
  detailText: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    paddingTop: 1,
  },
  detailLabel: {
    fontSize: "0.72rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: theme.palette.text.secondary,
  },
  detailValue: {
    fontSize: "0.95rem",
    fontWeight: 600,
    color: "#1f2937",
  },
  detailSub: {
    fontSize: "0.8rem",
    color: theme.palette.text.secondary,
  },
  dialogActions: {
    padding: theme.spacing(1.5, 2.5, 2),
  },
  cancelBtn: {
    textTransform: "none",
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
  viewCasesBtn: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 10,
    padding: theme.spacing(0.75, 2.5),
  },
  joinMeetingBtn: {
    textTransform: "none",
    fontWeight: 600,
    padding: 0,
    minWidth: 0,
  },
}));
